module.exports = __webpack_public_path__ + "img/modl.ai_white.f03f4728.png";